import * as React from 'react';
import * as ReactDom from 'react-dom';
import $ from 'jquery';
import forEach from 'lodash/forEach';
import { PopupWindow } from '../src/components/sharedcomponents/PopupWindow';
import UserRights from '../src/actions/UserRights';
export class RCUtils extends React.Component {
    constructor(props: any) {
        super(props);
    }
    //static FetchRequest(url: string): Request {
    //    var myInit = {};
    //    return new Request(url, myInit);
    //}

    static CheckAssesRightsForChassis(rightId: string) {
        var hasReefers: boolean = false;
        var hasGensets: boolean = false;
        var hasDrys: boolean = false;
        var hasChassis: boolean = false;
        var customerDetails: any = sessionStorage.getItem('customerDetails');
        var customer = JSON.parse(customerDetails);
        if (customer != null && customer != undefined) {
            if (customer.HasReefer)
                hasReefers = true;
            if (customer.HasGenset)
                hasGensets = true;
            if (customer.HasDry)
                hasDrys = true;
            if (customer.HasChassis)
                hasChassis = true;
        }
        if (UserRights.checkVisibility(rightId) == "show" && hasChassis == true) {
            return true;
        }
        else {

            return false;

        }
    }

    static HighlightCurrentGridRow(params, keyCode, selectedItems) {
        var selectflag = false;
        var selectedCell = params.api.getFocusedCell();
        var selectedRowIndex = selectedCell.rowIndex;
        var currentRow = params.api.getDisplayedRowAtIndex(selectedRowIndex);
        if (currentRow != null && currentRow != "undefined" && !currentRow.group) {
            var currentRowId = currentRow.id;
            var selectedrowNode = params.api.getRowNode(currentRowId);
            if (keyCode === "ReeferID") {
                var reeferid = selectedrowNode.data.ReeferID;
                params.api.forEachLeafNode((newRowNode, index) => {
                    if ((newRowNode.data.ReeferID === reeferid)) {
                        selectedrowNode = newRowNode;
                        return false;
                    }
                });
                $.each(selectedItems, (index, item) => {
                    if (item.ReeferID == selectedrowNode.data.ReeferID) {
                        selectflag = true;
                        return false;
                    }
                });
            }
            if (!selectflag)
                params.api.deselectAll();
            selectedrowNode.setSelected(true);
        }
    }

    static CheckAssesRightsForDrys(rightId: string) {
        var hasReefers: boolean = false;
        var hasGensets: boolean = false;
        var hasDrys: boolean = false;
        var hasChassis: boolean = false;
        var customerDetails: any = sessionStorage.getItem('customerDetails');
        var customer = JSON.parse(customerDetails);
        if (customer != null && customer != undefined) {
            if (customer.HasReefer)
                hasReefers = true;
            if (customer.HasGenset)
                hasGensets = true;
            if (customer.HasDry)
                hasDrys = true;
            if (customer.HasChassis)
                hasChassis = true;
        }
        if (UserRights.checkVisibility(rightId) == "show" && hasDrys == true) {
            return true;
        }
        else {

            return false;

        }

    }
    static CheckAssesRightsForReefers(rightId: string) {
        var hasReefers: boolean = false;
        var hasGensets: boolean = false;
        var hasDrys: boolean = false;
        var hasChassis: boolean = false;
        var customerDetails: any = sessionStorage.getItem('customerDetails');
        var customer = JSON.parse(customerDetails);
        if (customer != null && customer != undefined) {
            if (customer.HasReefer)
                hasReefers = true;
            if (customer.HasGenset)
                hasGensets = true;
            if (customer.HasDry)
                hasDrys = true;
            if (customer.HasChassis)
                hasChassis = true;
        }
        if (UserRights.checkVisibility(rightId) == "show" && hasReefers == true) {
            return true;
        }
        else {

            return false;

        }

    }
    static CheckAssesRightsForGensets(rightId: string) {
        var hasReefers: boolean = false;
        var hasGensets: boolean = false;
        var hasDrys: boolean = false;
        var hasChassis: boolean = false;
        var customerDetails: any = sessionStorage.getItem('customerDetails');
        var customer = JSON.parse(customerDetails);
        if (customer != null && customer != undefined) {
            if (customer.HasReefer)
                hasReefers = true;
            if (customer.HasGenset)
                hasGensets = true;
            if (customer.HasDry)
                hasDrys = true;
            if (customer.HasChassis)
                hasChassis = true;
        }
        if (UserRights.checkVisibility(rightId) == "show" && hasGensets == true) {
            return true;
        }
        else {

            return false;

        }

    }
    static CheckAssesRightsOnly(rightId: string) {

        if (UserRights.checkVisibility(rightId) == "show") {
            return true;
        }
        else {
            return false;
        }

    }
    static FetchRequest(url: string, options?: any) {
        var myInit = {};
        var requestHeaders = new Headers();
        requestHeaders.append('pragma', 'no-cache');
        requestHeaders.append('cache-control', 'no-cache');

        var JWTToken = sessionStorage.getItem('JWTToken');
        if (JWTToken != undefined && JWTToken != null) {
            requestHeaders.append("Authorization", "baerer " + JWTToken);
        }

        myInit = {
            headers: requestHeaders
        };
        if (options != undefined && options != null) {
            if (options.headers != undefined) {
                //requestHeaders = options.headers;
                forEach(options.headers, function (value, key) {
                    requestHeaders.append(key, value);
                });
            }

            myInit = {
                method: options.method,
                headers: requestHeaders,
                body: options.body
            };
        }
        return new Request(url, myInit);
    }
    static handleError(response, request?: Request): Promise<Response> {
        if (parseInt(response.status) != 200) {
            $('.loader-global').hide();
        }

        if (response.status == "401") {
            //response.text().then(function (text) {
            //    PopupWindow.showErrorMessage('Error', text);
            //});
            window.location.href = "unauthorized";
        }
        //if (!response.ok) throw new Error(response.statusText);

        if (response.status == "500") {
            var responsetext = '';
            response.text().then(function (text) {
                PopupWindow.showErrorMessage('Error', 'Error occurred. Please try again.');
                //responsetext = text;
                //var responsejson = JSON.parse(text);
                //if (responsejson.FaultCanRetry == true) {

                //}
            });
            //throw new Error(response.statusText)            
        }

        return response;
    }
    static handleOktaError(response, request?: Request): Promise<Response> {
        if (parseInt(response.status) != 200) {
            var preloader = document.getElementById("preloader");
            preloader.classList.add("hidden");
        }

        if (response.status == "401") {
            //response.text().then(function (text) {
            //    PopupWindow.showErrorMessage('Error', text);
            //});
            window.location.href = "unauthorized";
        }

        if (response.status == "500") {
            var responsetext = '';
            response.text().then(function (text) {
                PopupWindow.showErrorMessage('Login Error', 'Error occurred. Please try again.');
            });
        }

        return response;
    }
    static handleResponse(response): Promise<Response> {
        return response;
    }
    static retryError(response, request?: Request): Promise<Response> {
        if (response.status == "401") {
            //response.text().then(function (text) {
            //    PopupWindow.showErrorMessage('Error', text);
            //});
            window.location.href = "unauthorized";
        }
        //if (!response.ok) throw new Error(response.statusText);

        if (response.status == "500") {
            throw new Error(response.statusText);
        }
        return response;
    }
    static readresponse(response) {
        var deferred = $.Deferred();
        var test_data = "Hello World!"

        // SIMULATE SOME TIME TO PROCESS FUNCTION
        setTimeout(function () {
            // This line is what resolves the deferred object
            // and it triggers the .done to execute
            deferred.resolve(test_data);
        }, 2000) // AFTER 2 SECONDS IT WILL RETURN

        return deferred.promise();
    }

    static fetchRetry(request: Request, delay = 1000, limit = 3) {
        return new Promise((resolve, reject) => {
            function success(response) {
                resolve(response);
            }
            function failure(error) {
                limit--;
                if (limit) {
                    setTimeout(fetchUrl, delay)
                }
                else {
                    // this time it failed for real
                    reject(error);
                }
            }
            function finalHandler(finalError) {
                throw finalError;
            }
            function fetchUrl() {
                var newrequest = new Request(request.clone());
                return fetch(newrequest)
                    .then(RCUtils.retryError)
                    .then(success)
                    .catch(failure)
                    .catch(finalHandler);
            }
            fetchUrl();
        });

    }
    static faultretryResponse1(response) {
        return new Promise((resolve, reject) => {
            function success(response) {
                resolve(response);
            }
            function failure(error) {
                reject(error);
            }
            function finalHandler(finalError) {
                throw finalError;
            }
            function fetchResponse() {
                response.clone().text().then(function (text) {
                    var responsejson = JSON.parse(text);
                    if (responsejson.FaultCanRetry == true) {
                        throw new Error(response.statusText);
                    }
                })
                    .then(success)
                    .catch(failure)
                    .catch(finalHandler);
            }
            fetchResponse();
        })
    }
    static faultretryResponse(fresponse) {
        return new Promise((resolve, reject) => {
            function success(response) {
                resolve(fresponse);
                //resolve({
                //    data: fresponse.json(),
                //    status: response.status
                //});
            }
            function failure(error) {
                reject(error);
            }
            fresponse.clone().text().then(function (text) {
                var responsejson = JSON.parse(text);
                if (responsejson.FaultCanRetry == true) {
                    throw new Error(fresponse.statusText);
                }
            })
                .then(success)
                .catch(failure)
        });
    }
    static fetchFaultRetry(request: Request) {
        var delay = 1000, retrycount = 0;
        return new Promise((resolve, reject) => {
            function success(response) {
                resolve(response);
            }
            function failure(error) {
                retrycount++;
                setTimeout(fetchUrl, delay);

            }
            function finalHandler(finalError) {
                throw finalError;
            }
            function fetchUrl() {
                var newrequest = new Request(request.clone());
                //newrequest.headers.append('retrycount', retrycount.toString());
                return fetch(newrequest)
                    .then(RCUtils.faultretryResponse)
                    .then(success)
                    .catch(failure)
                    .catch(finalHandler);
            }
            fetchUrl();
        });

    }

    static RenderChildComponent(elementid, reactelement: React.ComponentElement<any, any>, delay: number = 500) {
        //setTimeout(function () {
        //    $(document).ready(function () {               
        //        ReactDom.render(reactelement, document.getElementById(elementid));
        //    })
        //}, delay);
        var selector = '#' + elementid;
        var waitForEl = function (selector, callback) {
            if ($(selector).length) {
                callback();
            } else {
                setTimeout(function () {
                    waitForEl(selector, callback);
                }, delay);
            }
        };
        waitForEl(selector, function () {
            ReactDom.render(reactelement, document.getElementById(elementid));
        });
    }
}


